import {Button, Flex, Tabs} from "antd";
import React, {useEffect, useState} from "react";
import {useAppDispatch, useAppSelector} from "../../feature/tools";
import {StorageProviders} from "../../storage/providers/StorageProviders";
import {StorageProviderSettings} from "../../storage/providers/StorageProvider";
import {loadStorageSettings, saveStorageSettings} from "../../feature/project/storageSlice";
import Title from "antd/es/typography/Title";
import {saveAiSettings} from "../../feature/project/aiSlice";

export const StorageSettings = (
    props: {
        saveFunction: (saveFunction: () => void) => void
    }
) => {
    const dispatch = useAppDispatch()
    const storageProviderSettings = useAppSelector(state => state.storageSlice.storageProviderSettings)
    const [storageSettings, setStorageSettings] = useState<StorageProviderSettings[]>(storageProviderSettings)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        setLoading(true)
        dispatch(loadStorageSettings())
        setLoading(false)
    }, []);

    useEffect(() => {
        setStorageSettings(storageProviderSettings)
    }, [storageProviderSettings])

    useEffect(() => {
        props.saveFunction(() =>  dispatch(saveStorageSettings({settings: storageSettings})))
    }, [storageSettings]);

    return (
        <Flex vertical={true} gap={10}>
            <Title level={5} style={{margin: 0, paddingTop: 10}}>Storage Settings</Title>
            <StorageProviders
                settings={storageSettings}
                onChange={(settings) => {
                    setStorageSettings(settings)
                }}
            />
        </Flex>
    )

}